/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateCertificateMutationRequest,
  UpdateCertificateMutationResponse,
  UpdateCertificatePathParams,
} from "../types/UpdateCertificate.ts"

export const updateCertificateMutationKey = () =>
  [{ url: "/v1/certificate/update-certificate/:id" }] as const

export type UpdateCertificateMutationKey = ReturnType<
  typeof updateCertificateMutationKey
>

/**
 * @summary Update a certificate
 * {@link /v1/certificate/update-certificate/:id}
 */
export async function updateCertificate(
  id: UpdateCertificatePathParams["id"],
  data: UpdateCertificateMutationRequest,
  config: Partial<RequestConfig<UpdateCertificateMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateCertificateMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateCertificateMutationRequest
  >({
    method: "POST",
    url: `/v1/certificate/update-certificate/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateCertificateMutationOptions(
  config: Partial<RequestConfig<UpdateCertificateMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = updateCertificateMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateCertificateMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateCertificatePathParams["id"]
      data: UpdateCertificateMutationRequest
    },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateCertificate(id, data, config)
    },
  })
}

/**
 * @summary Update a certificate
 * {@link /v1/certificate/update-certificate/:id}
 */
export function useUpdateCertificate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateCertificateMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        id: UpdateCertificatePathParams["id"]
        data: UpdateCertificateMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateCertificateMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateCertificateMutationKey()

  const baseOptions = updateCertificateMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateCertificateMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateCertificatePathParams["id"]
      data: UpdateCertificateMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateCertificateMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateCertificatePathParams["id"]
      data: UpdateCertificateMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateCertificateMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateCertificatePathParams["id"]
      data: UpdateCertificateMutationRequest
    },
    TContext
  >
}
